export enum SyllabusStatusChangeReason {
  Exception = 'Exception',
  QAProcess = 'QA Process',
}
